import { FunctionComponent, useMemo } from 'react';
import { StarIcon } from '../../../../../components/Icons';
import calculatePercentage from '../../../../../services/numbers/calculatePercentage';
import styles from './styles.module.scss';

type HeadingProps = {
    count: number;
    rating: number;
};

const Heading: FunctionComponent<HeadingProps> = ({ count, rating }) => {
    const percentage = useMemo(() => {
        return calculatePercentage(rating, 5);
    }, [rating]);

    return (
        <div className={styles.heading}>
            <h3>
                <StarIcon fillPercentage={percentage} className={styles.reviewsStar} />
                <span className={styles.reviewsRating}>{rating.toFixed(1)}</span>
                <span className={styles.reviewsCount}>({count})</span>
            </h3>
        </div>
    );
};

export default Heading;
